export default __webpack_public_path__ + "static/logoticker_menshealth-e932cf77f4fd59ff6003c75648618cc4.svg";